import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/createClass";
var SQL_NAME = process.env.VUE_APP_EXPORTATION;
var DB_NAME = "dataCenter";

var indexDb = /*#__PURE__*/function () {
  function indexDb() {
    _classCallCheck(this, indexDb);
  }

  _createClass(indexDb, [{
    key: "init",
    value: function init() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.request = window.indexedDB.open(SQL_NAME);

        _this.request.onerror = function (event) {
          reject(event);
          Toast("缓存获取失败");
        };

        _this.request.onsuccess = function (event) {
          resolve(event.target.result);
          _this.db = event.target.result;
        };

        _this.request.onupgradeneeded = function (event) {
          _this.db = event.target.result;
          var objectStore;

          if (!_this.db.objectStoreNames.contains(DB_NAME)) {
            objectStore = _this.db.createObjectStore(DB_NAME, {
              keyPath: "name",
              unique: true // 名称作为主键不允许重复

            });
            objectStore.createIndex("content", "content", {
              unique: false
            });
          }
        };
      });
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  try {
                    var transaction = _this2.db.transaction([DB_NAME], "readonly");

                    var objectStore = transaction.objectStore(DB_NAME);
                    var req = objectStore.get(name);

                    req.onsuccess = function () {
                      resolve(req.result);
                    };

                    req.onerror = reject;
                  } catch (_unused) {
                    // const dbInstance = new indexDb();
                    _this2.delIndexDb().then(function (res) {
                      _this2.init().then(function (db) {
                        resolve({
                          code: 500
                        });
                      }).catch(function (error) {});
                    });
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(name, content) {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var select = _this3.db.transaction([DB_NAME], "readwrite").objectStore(DB_NAME).add({
                    name: name,
                    content: content
                  });

                  select.onsuccess = function (event) {
                    resolve(event.target.result);
                  };

                  select.onerror = reject;
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function add(_x2, _x3) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name, content) {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  var select = _this4.db.transaction([DB_NAME], "readwrite").objectStore(DB_NAME).put({
                    name: name,
                    content: content
                  });

                  select.onsuccess = function (event) {
                    resolve(event.target.result);
                  };

                  select.onerror = reject;
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function update(_x4, _x5) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delIndexDb",
    value: function delIndexDb() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.db.close();

        var deleteRequest = window.indexedDB.deleteDatabase(SQL_NAME); // 监听成功事件

        deleteRequest.onsuccess = function (event) {
          console.log('数据库删除成功');
          resolve();
        }; // 监听错误事件


        deleteRequest.onerror = function (event) {
          console.error('删除数据库时发生错误:', event.target.error);
        }; // 监听阻塞事件


        deleteRequest.onblocked = function (event) {
          console.log('数据库删除被阻塞，可能有其他连接正在使用该数据库。');
        };
      });
    }
  }]);

  return indexDb;
}();

export default indexDb;